import React from 'react';
import { Theme } from '@mui/material';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { SxProps } from '@mui/system/styleFunctionSx';
import { mergeSx } from '@jucy-ui/appearance';
import { BlockContainer } from '@/components/Blocks/BlockContainer';
import { BlockTitle } from '@/components/Blocks/components/BlockTitle';
import { MarketingCard } from '@/components/Cards/MarketingCard';
import { CmsHtmlContent } from '@/components/CmsHtmlContent';
import { CmsMarketingCardsBlock } from '@/services/cms/blocks/CmsMarketingCardsBlock';

export interface MarketingCardsBlockProps extends CmsMarketingCardsBlock {
    sx?: SxProps<Theme>;
}

export const MarketingCardsBlock = ({ sx, ...props }: MarketingCardsBlockProps) => {
    const { content, marketingCards } = props;
    return (
        <BlockContainer {...props}>
            <BlockTitle
                {...props}
                sx={mergeSx(
                    {
                        marginBottom: 0,
                    },
                    sx
                )}
            />
            <Typography sx={{ fontSize: 12, mb: 4, px: { xs: 0, sm: 1, md: 2 }, lineHeight: 1.8, maxWidth: 952, mx: 'auto' }}>
                <CmsHtmlContent html={content} plain={true} />
            </Typography>
            <Grid container rowSpacing={2} columnSpacing={{ sm: 1, md: 2 }}>
                {marketingCards.map((card, index) => (
                    <Grid key={card.id ?? index} item xs={12} sm={6} lg={4} xl={3}>
                        <MarketingCard {...card} />
                    </Grid>
                ))}
            </Grid>
        </BlockContainer>
    );
};
